/* UA free shipping bar — standalone (no shipping widget required) */
(function () {
  const SEL = '.ua-freebar';
  const FREE_UP = 400;
  const FREE_NP = 1500;

  if (window.UAFreebar) return;
  const state = { aborter: null, lastTotal: null, ticking: false };

  const $all = () => Array.from(document.querySelectorAll(SEL));
  const clamp = (x, a, b) => Math.max(a, Math.min(b, x));
  const fmt = (n) => Math.max(0, Math.ceil(n)).toLocaleString('uk-UA') + ' ₴';

  function setDrawerOpen(open) {
    document.documentElement.classList.toggle('ua-cart-drawer-open', !!open);
  }

  function isDrawerOpen() {
    return !!(
      document.documentElement.classList.contains('ua-cart-drawer-open') ||
      document.querySelector('.cart-drawer__body, #CartDrawer.is-open, #CartDrawer[open]')
    );
  }

  function render(total) {
    const needUp = Math.max(0, FREE_UP - total);
    const needNp = Math.max(0, FREE_NP - total);
    const pct = clamp((total / FREE_NP) * 100, 0, 100);

    $all().forEach(wrap => {
      const fill = wrap.querySelector('.ua-freebar__fill');
      if (fill) fill.style.width = pct + '%';

      const lineA = wrap.querySelector('.ua-freebar__line--active');
      const lineB = wrap.querySelector('.ua-freebar__line--both');

      if (lineA) {
        if (total < FREE_UP) {
          lineA.textContent = `Ще ${fmt(needUp)} до безкоштовної доставки Укрпоштою`;
        } else if (total < FREE_NP) {
          lineA.textContent = `Укрпошта: безкоштовно ✅ · Ще ${fmt(needNp)} до безкоштовної доставки Новою поштою`;
        } else {
          lineA.textContent = 'Укрпошта: безкоштовно ✅ · Нова пошта: безкоштовно ✅';
        }
      }

      if (lineB) {
        lineB.textContent =
          `УП: ${needUp === 0 ? 'безкоштовно ✅' : 'ще ' + fmt(needUp)} · ` +
          `НП: ${needNp === 0 ? 'безкоштовно ✅' : 'ще ' + fmt(needNp)}`;
      }
    });
  }

  const schedule = (() => {
    let t = null;
    return (ms = 200) => {
      clearTimeout(t);
      t = setTimeout(update, ms);
    };
  })();

  async function fetchTotal() {
    try {
      if (state.aborter) state.aborter.abort();
      state.aborter = new AbortController();
      const res = await fetch('/cart.js', { credentials: 'include', signal: state.aborter.signal });
      const json = await res.json();
      return (json.total_price || 0) / 100;
    } catch (_) {
      return state.lastTotal ?? 0;
    }
  }

  async function update() {
    if (state.ticking) return;
    state.ticking = true;
    const total = await fetchTotal();
    state.lastTotal = total;
    render(total);
    state.ticking = false;
  }

  window.updateBars = window.updateBars || function () { schedule(0); };

  (function patchFetch() {
    if (window.__uaFreebarFetchPatched) return;
    window.__uaFreebarFetchPatched = true;
    const orig = window.fetch;
    window.fetch = async function (...args) {
      const res = await orig.apply(this, args);
      try {
        const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
        if (/\/cart(\/|\.js|\/add|\/change|\/update|\/clear)/.test(url)) schedule(220);
      } catch (_) {}
      return res;
    };
  })();

  ['click', 'input', 'change'].forEach(evt => {
    document.addEventListener(evt, (e) => {
      const t = e.target;
      if (!t) return;
      if (t.matches('button[name="plus"], button[name="minus"], .quantity__button') || t.matches('input[name^="updates"]')) {
        schedule(220);
      }
    }, true);
  });

  document.addEventListener('DOMContentLoaded', () => schedule(0));

  (function setupCartDrawerSync() {
    function sync() {
      const open = !!document.querySelector('.cart-drawer__body, #CartDrawer.is-open, #CartDrawer[open]');
      setDrawerOpen(open);
    }

    const mo = new MutationObserver(() => setTimeout(sync, 0));
    mo.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'aria-hidden', 'open'] });

    document.addEventListener('click', e => {
      if (e.target.closest('[data-sidebar-button][data-sidebar-id="CartDrawer"]')) {
        setTimeout(sync, 50);
      }
    });

    sync();
    window.UAFreebar = { update: () => schedule(0), setCartOpen: setDrawerOpen };
  })();
})();
